module.exports = __webpack_public_path__ + "static/img/bronze1.e328f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/bronze1.png
// module id = CPPe
// module chunks = 2